import { Card } from "@/components/atoms/Card/card"
import { ExpandableContent } from "../ExpandableContent/expandable-content"
import Rating from "../Rating/rating"

export type ReviewCardProps = {
  createdAt: string
  author: string
  rating: number
  body: string
}

export const ReviewCard = ({ createdAt, author, rating, body }: ReviewCardProps) => {
  return (
    <Card key={createdAt} className="min-w-[280px] max-w-[280px] p-4">
      <div className="flex flex-col items-center justify-between space-y-2">
        <div className="flex w-full flex-col-reverse items-center justify-between gap-2">
          <span className="text-xs text-gray-500">
            {new Date(createdAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
          <h3 className="font-semibold">{author}</h3>
        </div>
        <Rating stars={rating} />
      </div>
      <ExpandableContent lines={4}>
        <p className="mt-4 text-center text-gray-500">{body}</p>
      </ExpandableContent>
    </Card>
  )
}
